<template>
  <div class="Cont01">
    <p class="Cont01_A1" v-if="newMajor" :style="{color:obj.color}">{{ rate }}%</p>
    <p class="Cont01_B1" v-if="newMajor">录取概率</p>
    <p class="Cont01_C1" v-if="newMajor" :style="{background:obj.color}">{{obj.name}}</p>
    <div  v-if="!newMajor" style="font-size: 14px;padding-left: 10px;padding-right: 10px;text-align: center;" :style="{color:obj.color}">
      {{msg}}
    </div>
  </div>
</template>

<script>
  export default {
    props: {

      rate: {
        type: Number
      },
      newMajor:{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {
		msg:"新增专业，不做推荐，自主填报",
        obj:{name:'冲一冲',color:'#FF513E'}
      };
    },
    methods: {
      getrateStyle(rate, n) {

      },
    },
    mounted() {},
    created() {
		if(this.$utils.getlocalStorage("tianbaoType")!=0){
		this.msg = "新增专业，不做推荐，自主填报";
		}
    // if(this.newMajor == 0){
    // this.msg = "新增院校，不做推荐，自主填报";
    // }

      if (this.rate < this.$rate.fxg) {
        this.obj = {name:'风险高',color:'#de3f34'}
      }else if (this.rate >= this.$rate.fxg&&this.rate <= this.$rate.cyc) {
        this.obj = {name:'冲一冲',color:'#FF513E'}
      } else if (this.rate > this.$rate.cyc && this.rate <= this.$rate.wyw) {
        this.obj = {name:'稳一稳',color:'#fe9b0e'}
      } else if (this.rate > this.$rate.wyw && this.rate <= this.$rate.byb) {
        this.obj = {name:'保一保',color:'#0081cc'}
      } else if (this.rate > this.$rate.byb) {
        this.obj = {name:'垫一垫',color:'#00B54F'}
      }
    }
  };
</script>

<style scoped>
  .Cont01 {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .Cont01 .Cont01_A1 {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 40px;
    color: #FF513E;
  }

  .Cont01 .Cont01_A2 {
    color: #fe9b0e !important;
  }

  .Cont01 .Cont01_A3 {
    color: #0081cc !important;
  }

  .Cont01 .Cont01_A4 {
    color: #00B54F !important;
  }

  .Cont01 .Cont01_C2 {
    background: #fe9b0e !important;
  }

  .Cont01 .Cont01_C3 {
    background: #0081cc !important;
  }

  .Cont01 .Cont01_C4 {
    background: #00B54F !important;
  }

  .Cont01 .Cont01_B1 {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 17px;
    color: #999999;
  }

  .Cont01 .Cont01_C1 {
    width: 68px;
    height: 22px;
    display: block;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    line-height: 22px;
    background: #F53824;
    border-radius: 11px;
    margin-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/rateInfo.vue